import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AccordionItemWorker from 'component/Accordion/AccordionItemWorker';

class Accordion extends Component {

    static propTypes = {
        initialOpenedIndex: PropTypes.number,
        initialOpenedKey: PropTypes.number,
        blockTitleClass: PropTypes.string,
        closedTitleClass: PropTypes.string,
        openedTitleClass: PropTypes.string,
        blockBodyClass: PropTypes.string,
        closedBodyClass: PropTypes.string,
        openedBodyClass: PropTypes.string,
    };

    constructor() {
        super();
        this.state = {
            openedIndex: null,
            initialOpenedKey: null
        };
        this.handleToggle = this.handleToggle.bind(this);
    }

    componentDidMount() {
        const initialOpenedIndex = parseInt(this.props.initialOpenedIndex, 10);
        const initialOpenedKey = parseInt(this.props.initialOpenedKey, 10);
        this.setState({
            openedIndex: isFinite(initialOpenedIndex) ? initialOpenedIndex : null,
            initialOpenedKey: isFinite(initialOpenedKey) ? initialOpenedKey : null,
        });
    }

    handleToggle(index) {
        this.setState({
            openedIndex: index !== this.state.openedIndex ? index : null,
        });
    }

    render() {
        return (
            <div>
                {!!this.props.children && this.props.children.map((item, index) => {
                    let opened = index === this.state.openedIndex || item.props.opened || item.key == this.state.initialOpenedKey;

                    if (opened) {
                        this.state.openedIndex = index;
                        this.state.initialOpenedKey = null;
                    }

                    return (
                        <AccordionItemWorker key={item.key}
                            index={index}
                            title={item.props.title}
                            onToggle={this.handleToggle}
                            opened={index === this.state.openedIndex}
                            blockTitleClass={this.props.blockTitleClass}
                            closedTitleClass={this.props.closedTitleClass}
                            openedTitleClass={this.props.openedTitleClass}
                            blockBodyClass={this.props.blockBodyClass}
                            closedBodyClass={this.props.closedBodyClass}
                            openedBodyClass={this.props.openedBodyClass}>
                            {item.props.children}
                        </AccordionItemWorker>
                    );
                })}
            </div>
        );
    }
}

export default Accordion;